import React, { useEffect, useCallback, useState} from 'react';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';

let OPTIONS = [
    {value: -12, label: "-12db"},
    {value: -24, label: "-24db"},
    {value: -48, label: "-48db"},
];
const RolloffDropdown = ({formant, rolloff}) => { 
    const onChange = useCallback((o) => {
        formant.formantRolloffParameter.set(o.value);
    }, [formant]);
    return (
        <Dropdown
          className='osc-type-dropdown'
          controlClassName='osc-type-control-dropdown'
          arrowClassName='osc-type-arrow-dropdown'
          options={OPTIONS}
          onChange={onChange}
          value={OPTIONS.find(x => x.value === rolloff)}
          placeholder="Rate" />
    );
}

const mapStateToProps = (state, props) => {
  return {
      rolloff: props.formant.rolloff
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RolloffDropdown);
